import React, {useContext} from "react";
import {ContentContext} from "../../ContentContext";
import {getDirectusImage} from "../../api/directus";
import {CustomCard} from "../common/index";
import ArrowIcon from "../common/ArrowIcon";

function Tours() {
    const data = useContext(ContentContext);

    if (!data?.showSections.includes("tours")) {
        return null;
    }

    const tours = data?.tours?.map((item) => ({
        ...item,
        imagePath: getDirectusImage(item?.image),
    }));

    return (
        <section className={"tours"}>
            <h2>{data?.toursTitle}</h2>
            <span className={"tours-description"} dangerouslySetInnerHTML={{__html: data?.toursDescription}} />
            <div className={"tours-notice"}>
                <div className={"tours-notice-text"}>{data?.toursNoticeText}</div>
                <div className={"tours-notice-icon"}>
                    <ArrowIcon />
                </div>
                <div className={"tours-notice-legal"}>{data?.toursNoticeLegalText}</div>
            </div>
            <div className={"tours-list"}>
                <CustomCard items={tours} variant={"pill"} linked />
            </div>
        </section>
    );
}

export default Tours;
